import { HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DocumentoResult } from 'src/app/models/common/DocumentoResult';
import { SolicitudSeccion } from 'src/app/models/common/enumModel';
import { IConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoModel';
import { ISolicitudDocumentoTecnicoModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel';
import { SolicitudDocumentoTecnicoModel } from 'src/app/models/solicitud/SolicitudDocumentoTecnicoModel';
// import { ISolicitudDocumentoTecnicoModel } from 'src/app/models/interfaces/solicitud/ISolicitudDocumentoTecnicoModel';
import { SolicitudDocumentosTecnicosService } from 'src/app/services/solicitud-documentos-tecnicos/solicitud-documentos-tecnicos.service';
import { SolicitudEquipoDocumentosService } from 'src/app/services/solicitud-equipo-documentos/solicitud-equipo-documentos.service';
import { SolicitudPersonaDocumentosService } from 'src/app/services/solicitud-persona-documentos/solicitud-persona-documentos.service';
import { SolicitudVehiculoDocumentosService } from 'src/app/services/solicitud-vehiculo-documentos/solicitud-vehiculo-documentos.service';

@Component({
  selector: 'app-adjuntar-documento',
  templateUrl: './adjuntar-documento.component.html',
  styleUrls: ['./adjuntar-documento.component.css'],
})
export class AdjuntarDocumentoComponent implements OnInit {
  // public progress: number = 0;
  public message: string = '';
  @Input() filename: string = '';
  @Input() codigoSolicitud: string = '';
  @Input() idSolicitud: number = 0;
  @Input() model!: SolicitudDocumentoTecnicoModel; //IConfiguracionDocumentoModel;
  @Output() public onUploadFinished = new EventEmitter();
  @Output() public onRemoveDocument = new EventEmitter();
  @Input() tipoSeccion!: SolicitudSeccion;

  constructor(
    private documentoPersonaService: SolicitudPersonaDocumentosService,
    private documentoEquipoService: SolicitudEquipoDocumentosService,
    private documentoVehiculoService: SolicitudVehiculoDocumentosService,
    private documentoTecnicoService: SolicitudDocumentosTecnicosService,
  ) {}

  ngOnInit(): void {}

  public uploadFile = (files: any) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    switch (this.tipoSeccion) {
      case SolicitudSeccion.Personal:
        this.documentoPersonaService
          .guardar(formData, this.codigoSolicitud, this.idSolicitud)
          .subscribe((event) => {
            if (event.type === HttpEventType.UploadProgress) {
              // this.progress = Math.round(100 * event.loaded / event.total);
            } else if (event.type === HttpEventType.Response) {
              const doc: DocumentoResult = JSON.parse(JSON.stringify(event.body));
              this.filename = doc.fileName;// fileToUpload.name;
              this.message = 'Upload success.';
              this.model.nombreArchivo = doc.fileName;// fileToUpload.name;
              this.model.rutaArchivo = doc.dbPath;
              this.onUploadFinished.emit(this.model);
            }
          });
        break;
      case SolicitudSeccion.Equipos:
        this.documentoEquipoService
          .guardar(formData, this.codigoSolicitud, this.idSolicitud)
          .subscribe((event) => {
            if (event.type === HttpEventType.UploadProgress) {
              // this.progress = Math.round(100 * event.loaded / event.total);
            } else if (event.type === HttpEventType.Response) {
              const doc: DocumentoResult = JSON.parse(JSON.stringify(event.body));
              this.filename = doc.fileName;// fileToUpload.name;
              this.message = 'Upload success.';
              this.model.nombreArchivo = doc.fileName;// fileToUpload.name;
              this.model.rutaArchivo = doc.dbPath;
              this.onUploadFinished.emit(this.model);
            }
          });
        break;
      case SolicitudSeccion.Vehiculos:
        this.documentoVehiculoService
          .guardar(formData, this.codigoSolicitud, this.idSolicitud)
          .subscribe((event) => {
            if (event.type === HttpEventType.UploadProgress) {
              // this.progress = Math.round(100 * event.loaded / event.total);
            } else if (event.type === HttpEventType.Response) {
              const doc: DocumentoResult = JSON.parse(JSON.stringify(event.body));
              this.filename = doc.fileName;// fileToUpload.name;
              this.message = 'Upload success.';
              this.model.nombreArchivo = doc.fileName;// fileToUpload.name;
              this.model.rutaArchivo = doc.dbPath;
              this.onUploadFinished.emit(this.model);
            }
          });
        break;
        case SolicitudSeccion.DocumentacionTecnica:          
          this.documentoTecnicoService
          .guardar(formData, this.codigoSolicitud, this.idSolicitud)
          .subscribe((event) => {
            if (event.type === HttpEventType.UploadProgress) {
              // this.progress = Math.round(100 * event.loaded / event.total);
            } else if (event.type === HttpEventType.Response) {
              const doc: DocumentoResult = JSON.parse(JSON.stringify(event.body));
              this.filename = doc.fileName;// fileToUpload.name;
              this.message = 'Upload success.';
              this.model.nombreArchivo = doc.fileName;// fileToUpload.name;
              this.model.rutaArchivo = doc.dbPath;
              this.onUploadFinished.emit(this.model);
            }
          });
    }
  };

  removerDocumentoSeleccionado(){
    this.model.nombreArchivo = '';
    
    this.onRemoveDocument.emit(this.model);
  }
}
